<template>
  <CardLayout v-bind="clickable ? { onClick: () => $emit('click') } : {}">
    <template #header>
      {{ $t('report.clients_title') }}
    </template>
    <div v-if="loading">
      <Loading />
    </div>
    <div v-else-if="clientsOverview" class="w-full space-y-3">
      <!-- Total clients prominent -->
      <div class="text-center">
        <span class="text-[24px] font-bold text-foreground">
          {{ clientsOverview.total_clients }}
        </span>
        <p class="text-[11px] text-muted-foreground mt-0.5">
          {{ $t('report.clients_total') }}
        </p>
      </div>

      <!-- New / Returning bar -->
      <div>
        <div class="flex w-full h-[6px] rounded-full overflow-hidden">
          <div
            class="h-full transition-all duration-500"
            :style="{
              width: clientsNewPct + '%',
              backgroundColor: '#10B981'
            }">
          </div>
          <div
            class="h-full transition-all duration-500"
            :style="{
              width: clientsReturningPct + '%',
              backgroundColor: '#6366F1'
            }">
          </div>
        </div>
        <div class="flex justify-between mt-1.5">
          <span class="text-[10px] font-semibold" style="color: #10B981">
            {{ $t('report.clients_new') }} {{ clientsNewPct.toFixed(0) }}%
          </span>
          <span class="text-[10px] font-semibold" style="color: #6366F1">
            {{ $t('report.clients_returning') }} {{ clientsReturningPct.toFixed(0) }}%
          </span>
        </div>
      </div>
    </div>
    <div v-else class="w-full flex flex-col items-center justify-center py-6">
      <p class="text-sm text-muted-foreground">{{ $t('data.unavailable') }}</p>
    </div>
  </CardLayout>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { SalesByClientsResponse } from '../../responses'
import CardLayout from '../CardLayout.vue'
import Loading from '../Loading.vue'

const props = withDefaults(defineProps<{
  clientsReport: SalesByClientsResponse | null | undefined
  loading: boolean
  clickable?: boolean
}>(), {
  clickable: true,
})

defineEmits<{
  click: []
}>()

const clientsOverview = computed(() => {
  return props.clientsReport?.overview ?? null
})

const clientsNewPct = computed(() => {
  const overview = clientsOverview.value
  if (!overview || overview.total_clients === 0) return 0
  return (overview.new_clients / overview.total_clients) * 100
})

const clientsReturningPct = computed(() => {
  const overview = clientsOverview.value
  if (!overview || overview.total_clients === 0) return 0
  return (overview.returning_clients / overview.total_clients) * 100
})
</script>
